import React, { useState } from 'react';
import { MediumButton, PrimaryButton } from '../../../components/Buttons';
import { ModalContainer, ModalBody, ModalHeader, ModalFooter } from '../../../components/ModalElements';
import { VideoPlaceholder, LoadingVideoPlaceholder } from '../../../components/Layout';
import VideoPlayer from '../../../containers/VideoPlayer';
import ThirdPartyVideoPlayer from '../../../components/ThirdPartyVideoPlayer';
import HelpAndInfoBox from '../../../components/HelpAndInfoBox';
import { Task } from '../models/task';

const VideoTaskPreviewModal = ({
  task,
  buttonActionText,
  handleSubmit,
  handleDismiss,
}: {
  task: Task;
  buttonActionText: string;
  handleSubmit: () => void;
  handleDismiss: () => void;
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const videoId = task._type === 'ThirdPartyVideo' ? task.videoUrl : task.videoId;

  return (
    <ModalContainer dismissHandler={handleDismiss}>
      <ModalHeader data-qa-hook="VideoPreviewModal">
        <h3>Video Preview</h3>
      </ModalHeader>
      <ModalBody>
        <h3 style={{ marginBottom: '16px' }}>{task.taskName}</h3>
        {task._type === 'ThirdPartyVideo' ? (
          <VideoPlaceholder thirdParty>
            <ThirdPartyVideoPlayer url={videoId || ''} />
          </VideoPlaceholder>
        ) : (
          <VideoPlaceholder>
            {isLoading && <LoadingVideoPlaceholder />}
            <VideoPlayer setIsLoading={setIsLoading} videoId={videoId || ''} onEnd={() => null} />
          </VideoPlaceholder>
        )}
        <HelpAndInfoBox
          title=""
          description="This video is a preview of the full training. To access, please begin the training."
        />
      </ModalBody>
      <ModalFooter>
        <PrimaryButton onClick={handleSubmit}>{buttonActionText}</PrimaryButton>
        <MediumButton data-qa-hook="VideoPreviewCloseButton" onClick={handleDismiss}>
          Close
        </MediumButton>
      </ModalFooter>
    </ModalContainer>
  );
};

export default VideoTaskPreviewModal;
